import Head from "next/head";
import { GetStaticProps } from "next/types";

import SeoMetaData from "@/components/utils/seo-metadata";
import pageSeoData from "@/data/seo/page-data.json";
import CanadaPostMain from "@/components/fulfilment-partners/canada-post-main";
import { PageSeoHeaderProps } from "@/@types/SeoHeader";

export default function CanadaPostPartner({ seoData }: PageSeoHeaderProps) {
  return (
    <>
      <Head>
        <title>{seoData.title}</title>
        <SeoMetaData data={seoData} />
      </Head>

      <CanadaPostMain />
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: { seoData: pageSeoData.PARTNER_CANADA_POST },
  };
};
